import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Card from '@components/Card';
import Spinner from '@shared/Spinner';
import Screen from '@src/components/Screen/';

import ListsTable from './ListsTable';
import RulesTable from './RulesTable';
import SystemPerformance from './SystemPerformance';

const SpinnerContainer = styled.div`
  height: 80vh;
`;

export default function Main() {
  const apiKey = useSelector(state => state.keys.key);
  if (!apiKey) {
    return (
      <SpinnerContainer>
        <Spinner center />
      </SpinnerContainer>
    );
  }
  return (
    <>
      <Helmet>
        <title>Enigma API Console</title>
      </Helmet>
      <Screen />
      <Card title='System Performance' loading={false} mt={24}>
        <SystemPerformance />
      </Card>
      <Card title='Rules' loading={false} mt={24}>
        <RulesTable />
      </Card>
      <Card title='Lists' loading={false} mt={24}>
        <ListsTable />
      </Card>
    </>
  );
}
